import {withStyles} from '@material-ui/core/styles'
import React from 'react'
import {
  TopToolbar, CreateButton, Datagrid,
  EditButton, List, TextField, SelectField, ImageField
} from 'react-admin'

const ThumbnailImageField = withStyles({image: {height: 60}})(ImageField)

const styles = theme => ({
  title: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  hiddenOnSmallScreens: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  }
})
const Actions = ({basePath,}) => (
  <TopToolbar>
    <CreateButton basePath={basePath}/>
  </TopToolbar>
)

export default withStyles(styles)(({classes, ...props}) => {
  return (
    <List {...props}
          actions={<Actions/>}
          bulkActionButtons={false}>
      <Datagrid>
        <TextField source="id" sortable={false}/>
        <ThumbnailImageField source="imageMO" sortable={false}/>
        <SelectField source="type"
                     choices={[
                     {id: 'main', name: '메인'},
                     {id: 'goodsList', name: '상품리스트'},
                       {id: 'mainCenter', name: '메인 중앙'}
                     ]}
                     sortable={false}/>
        <EditButton/>
      </Datagrid>
    </List>
  )
})

